import { Link } from "react-router-dom";
import { getLatestArticles } from "@/mocks/articles";

const latestNews = getLatestArticles(6);

export default function LatestNews() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs tracking-[0.2em] text-accent-500 mb-2 font-medium">
              最新动态
            </p>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground-950">
              资讯速递
            </h2>
          </div>
          <Link
            to="/category/news"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            更多资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestNews.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-100 rounded-xl overflow-hidden hover:bg-background-100/80 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.category === "news" ? "新闻" : article.category === "interview" ? "专访" : "热议"}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors flex-1">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i> {article.likes.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1 text-sm text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap"
          >
            更多资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}